{
  "id": "campaign-036",
  "name": "Lazy Commons",
  "seed": "campaign:36",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "............",
    "............",
    "..........,,",
    "..T......T..",
    "............",
    "............",
    ".h..h..h..h.",
    "____________",
    ",.,.~.......",
    ".ww..~......",
    ".ww.b..b....",
    "............",
    ",...........",
    ".,......,,,x",
    ",......~~,..",
    ".....q.~....",
    ".#..........",
    "...........S"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 4,
      "y": 13
    },
    {
      "kind": "rabbit",
      "x": 1,
      "y": 2
    },
    {
      "kind": "squirrel",
      "x": 5,
      "y": 16
    },
    {
      "kind": "squirrel",
      "x": 6,
      "y": 4
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 2,
      "y": 1
    },
    {
      "kind": "gas",
      "x": 2,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 5
    },
    {
      "kind": "rare",
      "x": 1,
      "y": 7
    }
  ],
  "generatorVersion": 3,
  "level": 36,
  "biome": "park",
  "par": {
    "reel": 8096,
    "push": 6655,
    "selfPropelled": 6054,
    "tractor": 5145,
    "zeroTurn": 4155,
    "fairway": 2583
  },
  "routeTries": {
    "par": {
      "reel": 23,
      "push": 0,
      "selfPropelled": 12,
      "tractor": 0,
      "zeroTurn": 2,
      "fairway": 17
    }
  }
}
